module.exports = __webpack_public_path__ + "media/images/review/ico-human-s-20c42d42d2ed09eaa531ce227ebb19bb.svg";